;(function ($, window, document, undefined) {
    'use strict';

    var UserProfile = function (element, options) {
        this.opts      = options;
        this.els       = options.els;
        this.users     = 0;
        this.init();
    };

    UserProfile.prototype = {

        init : function () {
            this.fixGallerySize();
            this.tabs();
            this.addBadgesLinks();
            this.removeEmptySections();
        },

        removeEmptySections : function () {
            // if (!$('#userImageGalleryTaplet').find('li').size()) {
            //     $('.lia-quilt-row-row_7').hide();
            // }
        },

        addBadgesLinks : function () {
            var $list = $('#userBadgesList');
            var link  = $list.find('.lia-view-all a').attr('href');
            $list.find('.lia-user-badge-display').each(function () {
                $(this).find('img').wrap('<a href="' + link + '"></a>');
                $(this).find('.lia-user-badge-attributes').append('<div class="lia-user-badge-name">' + $(this).find('img').attr('title') + '</div>').wrap('<a href="' + link + '"></a>');
            });
        },

        fixGallerySize : function () {
            $( '.UploadedImageDisplay img' ).each(function () {
                $(this).attr('src', $(this).attr('src').replace('tiny','medium'));
            });
        },

        tabs : function () {
            $('#user-posts-filter').on('click', 'a', function (e) {
                e.preventDefault();
                if ($(this).parent().hasClass('current-tab')) {
                    return;
                }
                $(this).parent().addClass('current-tab').siblings().removeClass('current-tab');
                var dest = $(this).attr('href');

                if (dest == '#posts-i-liked') {
                    $('.lia-quilt-column-liked-posts').show().siblings().hide();

                } else {
                    $('.lia-quilt-column-latest-posts').show().siblings().hide();
                }
            });
        },

        layout : function () {
        }

    };

    $.fn.UserProfile = function (options){

        var args     = Array.prototype.slice.call(arguments, 1),
            $item    = $(this),
            instance = $item.data( 'UserProfile' );

        if (!instance) {
            instance = new UserProfile(this, options);
            $item.data('UserProfile', instance);
        }

        if (typeof options === 'string') {
            instance[options].apply(instance, args);
        }

        return this;
    };

})(jQuery, window, document);
